import ApiClient from './ApiClient';

class CustomPromptTemplateAPI extends ApiClient {
  constructor() {
    super('custom_prompt_templates', { accountScoped: true });
  }
}

export default new CustomPromptTemplateAPI();
